import { useEerieBackdrop } from "@/lib/eerie";
import { MatchKeyLanding } from "@/components/MatchKey/MatchKeyShell";
import { CHESS_CFG } from "@/components/MatchKey/cfgs";

export default function ChessLanding() {
  useEerieBackdrop("estampie");
  return <MatchKeyLanding cfg={CHESS_CFG} />;
}
